/* eslint-disable */

import toast from 'react-hot-toast'
import { apiClient, config, multiPartConfig } from './env'

export default {
  any: async (api, params, data) => {
    if (api.useAuth) {
      if (data instanceof FormData) {
        apiClient.setHeaders((await multiPartConfig()).headers)
      } else {
        apiClient.setHeaders((await config()).headers)
      }
    }
    const response = await apiClient.any({
      method: api.method,
      url: api.url,
      params: params,
      data: data,
    })

    if (response.status === 401) {
      console.log('Session expired, login again')
      return
    }

    if (response.status === 403) {
      console.log('Forbidden')
      return
    }

    if (response.ok) {
      if (response.data?.message) {
        toast.success(response.data.message)
      }

      return response.data
    }

    if (response.data?.errors) {
      const { errors } = response.data
      let error = Object.keys(errors)[0]
      console.log({ error })
      return -1
    }

    if (!response.ok && response.data?.message) {
      toast.error(response.data.message)
      return -1
    }
  },
}
